var map = {
	"./p1.jpg": 93,
	"./p2.jpg": 94,
	"./p3.jpg": 95,
	"./p4.jpg": 96,
	"./p5.jpg": 97,
	"./p6.jpg": 98,
	"./p7.jpg": 99,
	"./p8.jpg": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92;